<template>
  <v-btn icon class="delete-button" @click="showConfirmationDialog">
    <v-icon size="20px">stream-delete</v-icon>
    <v-dialog v-model="dialog" max-width="350">
      <v-card class="my-groups-delete pt-2 pb-2">
        <v-card-title class="justify-center">
          <div class="text-xs-center">
            <h2 class="mb-3">{{ $t('confirmation_title') }}</h2>
            <div>{{ $t('confirmation_text') }}</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-layout row justify-center class="pt-1 pb-3">
            <v-btn class="cancel-button mr-3"
                   :disabled="sending"
                   @click="hideConfirmationDialog">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn class="confirm-button"
                   :loading="sending"
                   @click="confirmDelete"
                   color="primary">
              {{ $t('confirm') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { DELETE_GROUP } from '../../../store/action-types'
  import { REMOVE_GROUP } from '../../../store/mutation-types'

  export default {
    name: 'MyGroupDelete',
    props: {
      group: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        dialog: false
      }
    },
    computed: {
      ...mapState({
        sending: state => state.groups.sending
      })
    },
    methods: {
      ...mapMutations({
        removeGroup: REMOVE_GROUP
      }),
      showConfirmationDialog () {
        this.dialog = true
      },
      hideConfirmationDialog () {
        this.dialog = false
      },
      confirmDelete () {
        let flag = this.group.name !== undefined ? false : this.group.rows[0] === 'untitled_group'
        this.$store.dispatch(DELETE_GROUP, {groupId: this.group.id, deleteFlag: flag}).then(() => {
          this.hideConfirmationDialog()
          this.removeGroup(this.group.id)
          this.$emit('deleted', this.group.id)
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/student/group/MyGroupDelete.vue